
import { LogOut } from 'lucide-react'; 
import { logout } from '../Auth/Auth.jsx';
import React from 'react';

const SignOut = () => {

  function signOff() {
    logout();
  }

  return (

    <button
      onClick={signOff}
      className='flex justify-center items-center gap-3 w-full p-3 rounded-lg text-left text-[#222731] border hover:bg-[#48CFCB] hover:text-[#222731] transition-colors duration-200'
    >
      <LogOut size={20} /> 
      <span>Sign out</span>     
    </button>
  );
}

export default SignOut;